var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#898991"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0417 8.45866C13.0417 9.03396 12.5753 9.50033 12 9.50033C11.4247 9.50033 10.9583 9.03396 10.9583 8.45866C10.9583 7.88336 11.4247 7.41699 12 7.41699C12.5753 7.41699 13.0417 7.88336 13.0417 8.45866Z",
    fill: "white",
    fillOpacity: 0.94
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 11.167V12.0003H11.1667V16.167H10.75V17.0003H13.25V16.167H12.8333V11.5837C12.8333 11.3535 12.6468 11.167 12.4167 11.167H10.75Z",
    fill: "white",
    fillOpacity: 0.94
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.217993907cfb4f1a9d60d520b0603656.svg";
export { ForwardRef as ReactComponent };